// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"693":"1ed78c0d","883":"ba6ff720"}[chunkId] + ".chunk.js";
};